import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useRouterState,
} from "@tanstack/react-router"
import { useEffect, useMemo } from "react"

import { FinanceSettingsLayoutSkeleton } from "@/components/skeletons/finance-settings-skeleton"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"

/**
 * Finance settings layout with tabs
 */
export const Route = createFileRoute(
  "/_authenticated/$orgSlug/settings/finance",
)({
  beforeLoad({ params, location }) {
    if (
      !location.pathname.endsWith("/categories") &&
      !location.pathname.endsWith("/accounts")
    ) {
      throw redirect({
        to: "/$orgSlug/settings/finance/accounts",
        params: { orgSlug: params.orgSlug },
      })
    }
  },
  loader: ({ params }) => {
    return {
      title: "Finanças",
      path: `/${params.orgSlug}/settings/finance`,
    }
  },
  component: FinanceSettingsLayout,
  pendingComponent: FinanceSettingsLayoutSkeleton,
})

function FinanceSettingsLayout() {
  const path = Route.useLoaderData()
  const { breadcrumbs } = Route.useRouteContext()
  const { orgSlug } = Route.useParams()
  const location = useRouterState({ select: (state) => state.location })

  const activeTab = useMemo(() => {
    if (location.pathname.endsWith("/categories")) {
      return "categories"
    }
    return "accounts"
  }, [location.pathname])

  useEffect(() => {
    breadcrumbs.setCurrentPath(path)
  }, [breadcrumbs, path])

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} className="w-full">
        <TabsList>
          <Link to="/$orgSlug/settings/finance/accounts" params={{ orgSlug }}>
            <TabsTrigger value="accounts">Contas</TabsTrigger>
          </Link>
          <Link to="/$orgSlug/settings/finance/categories" params={{ orgSlug }}>
            <TabsTrigger value="categories">Categorias</TabsTrigger>
          </Link>
        </TabsList>
      </Tabs>

      <Outlet />
    </div>
  )
}
